// 包场订单创建
export default {
    // 列表
    table_title: "项目订单列表",
    tl_projName: "项目名称",
    tl_space: "场地",
    tl_price: "价格",
    tl_date: "日期",
    tl_timeRange: "时间",
    tl_number: "数量",
    tl_amount: "小计",
    statistical_desc: "张车票 订单合计：",

    // 新增包场
    dl_title1: "新增包场",
    dl_title2: "编辑包场",
    dl_projName: "项目名称",
    dp_projName: "请选择项目",
    dl_space: "场地",
    dp_space: "请选择场地",
    dl_date: "日期",
    dp_date: "请选择日期",
    dl_price: "总价",
    dl_startTime: "开始时间",
    dp_startTime: "请选择开始时间",
    dl_endTime: "结束时间",
    dp_endTime: "请选择结束时间",
    dl_orderNum: "数量",
    dl_operator: "操作",
    btn_addItem: "加入订单",
    btn_editItem: "编辑订单",

    em_number: "数量不能为空",
    em_startTime: "请选择开始时间",
    em_endTime: "请选择结束时间",
    em_isSave: "已存在相同时间数据，请勿重复操作",

    sm_addItem: "加入成功",
    sm_editItem: "编辑成功",
    sm_cancelUse: "取消使用成功"
};
